import React from "react";
import { CheckoutItemsProps } from "../../../../store/modules/checkout/types";
import { ProductImg } from "./styles";

interface IProductImage {
  product: CheckoutItemsProps;
}

export function ProductImage({product}: IProductImage) {
    return (<>
        {
        product.product && (
            <ProductImg
                src={product.product.image_url}
                alt={product?.short_description}
            />
        )
        }
    </>)
}
